import { render, staticRenderFns } from "./TipoDocumentos.vue?vue&type=template&id=5f83145c&scoped=true"
import script from "./TipoDocumentos.vue?vue&type=script&lang=js"
export * from "./TipoDocumentos.vue?vue&type=script&lang=js"
import style0 from "./TipoDocumentos.vue?vue&type=style&index=0&id=5f83145c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83145c",
  null
  
)

export default component.exports